import React from 'react'

const FabricationHeader = () => {
  return (
   <div className="contact-header">
      <div className="overlay">
        <h1 className="contact-title" style={{color: '#00c14d'}}>PCB Fabrication</h1>
         <p style={{
          fontSize: '20px',
          color: 'white',
          marginTop: '10px',
          maxWidth: '80%',
          lineHeight: '1.5',
          margin: '0 auto',
        }}>
         Precision-Engineered PCB Fabrication – Where Innovation Meets Craftsmanship
        </p>
      </div>

      {/* Bottom Curve */}
      <svg className="header-curve" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
          fill="#ffffff"
        />
      </svg>
    </div>
  )
}

export default FabricationHeader
